import {
  AssetType,
  CalculationCountry,
  DkTaxCode,
  Owner,
  Payment,
  PaymentFrequency,
  PensionCoverage,
  Policy,
} from '@dreamplan/autogenerated-clients/calculation';
import { TestProfileWithAnswers } from '@dreamplan/types';
import { sharedDefaultAnswers } from '../sharedProfileAnswers';
export const JorgenLiseProfile: TestProfileWithAnswers = {
  name: 'Jorgen and Lise',
  answers: [
    ...sharedDefaultAnswers,
    {
      key: 'isUserSelfEmployed',
      value: 'false',
    },
    {
      key: 'userCurrentPensionMonthlyPayment',
      value: 7200,
    },
    {
      key: 'spouseCurrentPensionMonthlyPayment',
      value: 3600,
    },
    {
      key: 'userFullName',
      value: 'Jorgen',
    },
    {
      key: 'userPhoneNumber',
      value: '3203948',
    },
    {
      key: 'userAge',
      value: 1969,
    },
    {
      key: 'hasSpouse',
      value: 'true',
    },
    {
      key: 'spouseName',
      value: 'Lise',
    },
    {
      key: 'spouseAge',
      value: 50,
    },
    {
      key: 'userMonthlySalary',
      value: 80000,
    },
    {
      key: 'userCurrentPensionSavings',
      value: 2500000,
    },
    {
      key: 'spouseMonthlySalary',
      value: 20000,
    },
    {
      key: 'spouseCurrentPensionSavings',
      value: 500000,
    },
    {
      key: 'houseAddress',
      value: 'test adresse',
    },
    {
      key: 'houseOwnershipType',
      value: 'Own',
    },
    {
      key: 'houseValue',
      value: 5000000,
    },
    {
      key: 'houseDebt',
      value: 4000000,
    },
    {
      key: 'houseDebtInterest',
      value: 0.5,
    },
    {
      key: 'houseDebtRemainingTenure',
      value: 20,
    },
    {
      key: 'houseDebtHasRepaymentFreeYears',
      value: 'true',
    },
    {
      key: 'houseDebtRemainingRepaymentFreeYears',
      value: 3,
    },
    {
      key: 'userMonthlySavingsAmount',
      value: 5000,
    },
    {
      key: 'userCurrentEmergencySavings',
      value: 1000000,
    },
    {
      key: 'fetchPensionInformation',
      value: 'false',
    },
    {
      key: 'seeDataSecurity',
      value: 'false',
    },
    {
      key: 'hasSecondHouse',
      value: 'false',
    },
    {
      key: 'userName',
      value: 'Jorgen',
    },
  ],

  expectedPayload: {
    primary: {
      birthYear: 1969,
      pensionAge: 69,
      deathAge: undefined,
    },
    spouse: {
      birthYear: 1975,
      pensionAge: 69,
      deathAge: undefined,
    },
    incomes: [
      {
        id: 'primary-income',
        owner: Owner.Primary,
        payment: {
          type: 'Payment',
          paymentFrequency: PaymentFrequency.Monthly,
          amount: 80000,
        } as Payment,
      },
      {
        id: 'spouse-income',
        owner: Owner.Spouse,
        payment: {
          type: 'Payment',
          paymentFrequency: PaymentFrequency.Monthly,
          amount: 20000,
        } as Payment,
      },
    ],
    policies: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960p',
        owner: Owner.Primary,
        coverages: [
          {
            type: 'PensionCoverage',
            id: 'dd5f84da-066d-4610-8753-4d4e9fc8960p',
            owner: Owner.Primary,
            initialValue: 2500000,
            taxCode: DkTaxCode.One,
            contribution: {
              type: 'PensionContribution',
              paymentFrequency: PaymentFrequency.Monthly,
              amount: 7200,
            },
            payOutType: {
              type: 'LifeAnnuity',
            },
          } as PensionCoverage,
        ],
      } as Policy,
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc896sp',
        owner: Owner.Spouse,
        coverages: [
          {
            type: 'PensionCoverage',
            id: 'dd5f84da-066d-4610-8753-4d4e9fc896sp',
            owner: Owner.Spouse,
            initialValue: 500000,
            taxCode: DkTaxCode.One,
            contribution: {
              type: 'PensionContribution',
              paymentFrequency: PaymentFrequency.Monthly,
              amount: 3600,
            },
            payOutType: {
              type: 'LifeAnnuity',
            },
          } as PensionCoverage,
        ],
      } as Policy,
    ],
    housesWithLoans: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960f',
        houseValue: 5000000,
        type: 'HouseWithLoans',
        loans: [
          {
            id: 'd9497ef5-9d8a-4c03-8308-cbee6746339c',
            remainingPrincipal: 4000000,
            type: 'AmortizedLoan',
            contributionFeeRate: 0.006999999999999999,
            interestRate: 0.005,
            redemptionDetails: {
              // bondPrice: 0,
              redemptionFee: 5000,
            },
            remainingRepaymentFreeYears: 3,
            remainingTenure: 20,
          },
        ],
      },
    ],
    liquidAssets: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960h',
        assetType: AssetType.Stocks,
        initialValue: 1000000,
        monthlyDeposit: {
          type: 'Payment',
          amount: 5000,
          paymentFrequency: PaymentFrequency.Monthly,
        } as Payment,
      },
    ],
    municipalityId: undefined,
    companies: undefined,
    dreams: undefined,
    calculationCountry: CalculationCountry.Dk,
    recommendationSettings: {
      companyRecommendation: undefined,
      primaryPensionRecommendation: undefined,
      spousePensionRecommendation: undefined,
      emergencySavingRecommendation: undefined,
      loanRecommendation: {
        type: 'RestrictedLoanToValueRatioGoalSeek',
        ratio: undefined,
        establishmentDetails: {
          foundationFee: 20000,
          // bondPrice: 98,
        },
        // interestRate: 0.06,
        // contributionFeeRate: 0.02,
      },
    },
  },
  expectedResult: undefined,
};
